"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.RequestTour = void 0;
var react_1 = __importDefault(require("react"));
var Button_1 = __importDefault(require("@material-ui/core/Button"));
var Grid_1 = __importDefault(require("@material-ui/core/Grid"));
var styles_1 = require("@material-ui/core/styles");
var Typography_1 = __importDefault(require("@material-ui/core/Typography"));
var LimitTextField_1 = require("../common/LimitTextField");
var SelectDays_1 = require("../common/SelectDays");
var strings_1 = __importDefault(require("../strings"));
var useStyles = styles_1.makeStyles(function (theme) {
    return styles_1.createStyles({
        spacingBottomOne: {
            marginBottom: theme.spacing(1),
        },
        spacingTopThree: {
            marginTop: theme.spacing(3),
        },
        divider: {
            marginTop: theme.spacing(2),
            marginBottom: theme.spacing(2),
            height: 2,
        },
        instructions: {
            fontSize: "20px",
            marginBottom: theme.spacing(2),
        },
        tourDates: {
            fontSize: "18px",
            marginBottom: theme.spacing(2),
        },
        tourVirtual: {
            fontSize: "18px",
            fontWeight: "bold",
            marginBottom: theme.spacing(2),
        },
    });
});
var RequestTour = function (props) {
    var classes = useStyles(props);
    var _a = react_1.default.useState(), parentNotes = _a[0], setParentNotes = _a[1];
    var _b = react_1.default.useState([]), selectedDays = _b[0], setSelectedDays = _b[1];
    var _c = react_1.default.useState([]), selectedTimes = _c[0], setSelectedTimes = _c[1];
    var _d = react_1.default.useState(), dayOptions = _d[0], setDayOptions = _d[1];
    var _e = react_1.default.useState(), timeOptions = _e[0], setTimeOptions = _e[1];
    react_1.default.useEffect(function () {
        var arrayOfDates = [];
        var availableDays;
        var tourTimes;
        if (props.tourSchedule && props.tourSchedule.length) {
            availableDays = [1, 2, 3, 4, 5].filter(function (d) {
                return (props.tourSchedule.some(function (t) { return t.getDayOfWeek() === d; }));
            });
            tourTimes = [];
            var availableTimes_1 = Object.keys(strings_1.default.requestTour.dayTime).map(function (t) {
                var values = strings_1.default.requestTour.dayTime[t].split(":");
                return { time: t, startHour: values[0], endHour: values[1] };
            });
            props.tourSchedule.forEach(function (t) {
                availableTimes_1.forEach(function (a) {
                    if ((t.getStartHour() < a.endHour) && (t.getEndHour() > a.startHour)) {
                        if (tourTimes.indexOf(a.time) === -1) {
                            tourTimes.push(a.time);
                        }
                    }
                });
            });
        }
        else {
            availableDays = [1, 2, 3, 4, 5];
            tourTimes = Object.keys(strings_1.default.requestTour.dayTime);
        }
        if (props.weekdaysOnly) {
            availableDays.forEach(function (d) {
                arrayOfDates.push(strings_1.default.days[d - 1]);
            });
        }
        else {
            for (var i = 1; i < 8; i++) {
                var nextDay = new Date();
                nextDay.setDate(new Date().getDate() + i);
                if (availableDays.indexOf(nextDay.getDay()) > -1) {
                    var weekdayNames = strings_1.default.requestTour.weekdayNames;
                    var dayFormat = weekdayNames[nextDay.getDay()] + " " + (nextDay.getMonth() + 1).toString() + "/" + nextDay.getDate();
                    arrayOfDates.push(dayFormat);
                }
            }
        }
        setDayOptions(arrayOfDates);
        setTimeOptions(tourTimes);
    }, [props.tourSchedule, props.weekdaysOnly]);
    var onChangeDays = function (selected) {
        var days = selected.map(function (i) { return dayOptions[i]; });
        setSelectedDays(days);
        if (props.onChange) {
            props.onChange(parentNotes, days, selectedTimes);
        }
    };
    var onChangeTime = function (selected) {
        var times = selected.map(function (i) { return timeOptions[i]; });
        setSelectedTimes(times);
        if (props.onChange) {
            props.onChange(parentNotes, selectedDays, times);
        }
    };
    var onUpdateNotes = function (e) {
        setParentNotes(e.target.value);
        if (props.onChange) {
            props.onChange(e.target.value, selectedDays, selectedTimes);
        }
    };
    var combineStrings = function (str) {
        if (str.length === 1) {
            return str[0];
        }
        else if (str.length === 2) {
            return str[0] + " and " + str[1];
        }
        else {
            return str.slice(0, -1).join(", ") + ", and " + str[str.length - 1];
        }
    };
    var getTourSchedule = function (tourSchedules) {
        var formatTime = function (hour, minute) {
            var min = ("0" + minute).slice(-2);
            return ((hour % 12) ? (hour % 12) : 12) + ":" + min + " " + ((hour < 12) ? "AM" : "PM");
        };
        var formatDays = function (days) {
            var blocks = [];
            var currentBlock = [];
            days.forEach(function (d) {
                if (!currentBlock.length || (d.idx === currentBlock[currentBlock.length - 1].idx + 1)) {
                    currentBlock.push(d);
                }
                else {
                    if (currentBlock.length === 1) {
                        blocks.push(currentBlock[0].day);
                    }
                    else {
                        blocks.push(currentBlock[0].day + " - " + currentBlock[currentBlock.length - 1].day);
                    }
                    currentBlock = [d];
                }
            });
            if (currentBlock.length === 1) {
                blocks.push(currentBlock[0].day);
            }
            else {
                blocks.push(currentBlock[0].day + " - " + currentBlock[currentBlock.length - 1].day);
            }
            return combineStrings(blocks);
        };
        var scheduleString = function (schedules) {
            var tourTimes = [];
            strings_1.default.requestTour.weekdayNames.forEach(function (d, idx) {
                var dayTours = schedules.filter(function (t) { return t.getDayOfWeek() === idx; });
                if (dayTours.length) {
                    var times_1 = [];
                    dayTours.forEach(function (t) {
                        times_1.push(formatTime(t.getStartHour(), t.getStartMinute()) + " - " + formatTime(t.getEndHour(), t.getEndMinute()));
                    });
                    tourTimes.push({ day: d, idx: idx, times: times_1.join(" and ") });
                }
            });
            var tours = [];
            tourTimes.forEach(function (t) {
                var t2 = tours.find(function (tour) { return tour.times === t.times; });
                if (t2) {
                    t2.days.push({ day: t.day, idx: t.idx });
                }
                else {
                    tours.push({ days: [{ day: t.day, idx: t.idx }], times: t.times });
                }
            });
            var days = tours.map(function (t) { return formatDays(t.days) + " from " + t.times; });
            return combineStrings(days);
        };
        var schedule = "";
        if (tourSchedules && tourSchedules.length) {
            var ageGroups_1 = [];
            tourSchedules.forEach(function (t) {
                if (t.getAgeGroupId() && ageGroups_1.indexOf(t.getAgeGroupId()) === -1) {
                    ageGroups_1.push(t.getAgeGroupId());
                }
            });
            var allAgesSchedule = void 0;
            var allAges = tourSchedules.filter(function (t) { return !t.getAgeGroupId(); });
            if (allAges.length) {
                allAgesSchedule = scheduleString(allAges);
            }
            var ageGroupStrings_1 = [];
            ageGroups_1.forEach(function (a) {
                var ageGroupTours = tourSchedules.filter(function (t) { return (t.getAgeGroupId() === a); });
                ageGroupStrings_1.push(strings_1.default.requestTour.scheduleAgeGroup
                    .replace("{AgeGroup}", ageGroupTours[0].getAgeGroupName())
                    .replace("{Schedule}", scheduleString(ageGroupTours)));
            });
            if (allAgesSchedule) {
                if (ageGroups_1.length) {
                    schedule = strings_1.default.requestTour.scheduleWithAgeGroups
                        .replace("{Schedule}", allAgesSchedule)
                        .replace("{AgeGroups}", ageGroupStrings_1.join(" "));
                }
                else {
                    schedule = strings_1.default.requestTour.scheduleNoAgeGroups
                        .replace("{Schedule}", allAgesSchedule);
                }
            }
            else {
                schedule = ageGroupStrings_1.join(" ");
            }
        }
        return schedule;
    };
    var onSave = function () {
        if (props.onSave) {
            props.onSave(parentNotes, selectedDays, selectedTimes);
        }
    };
    var inPersonTours = [];
    var onlineTours = [];
    (props.tourSchedule || []).forEach(function (s) {
        if (s.getVirtual()) {
            onlineTours.push(s);
        }
        else {
            inPersonTours.push(s);
        }
    });
    return (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement(Grid_1.default, { container: true },
            react_1.default.createElement(Typography_1.default, { variant: "h6", className: classes.instructions }, strings_1.default.requestTour.instructions
                .replace("{Center}", props.centerName)),
            props.tourPolicy ? react_1.default.createElement(Typography_1.default, { variant: "h6", className: classes.instructions }, props.tourPolicy) : null,
            react_1.default.createElement(Grid_1.default, { container: true },
                (inPersonTours.length > 0) ? react_1.default.createElement(Grid_1.default, { item: true, xs: 12 },
                    react_1.default.createElement(Typography_1.default, { variant: "h6", className: classes.tourDates }, onlineTours.length
                        ? strings_1.default.requestTour.inPerson.replace("{Times}", getTourSchedule(inPersonTours))
                        : getTourSchedule(inPersonTours))) : null,
                (onlineTours.length > 0)
                    ? react_1.default.createElement(Typography_1.default, { variant: "h6", className: classes.tourVirtual }, strings_1.default.requestTour.virtual.replace("{Times}", getTourSchedule(onlineTours)))
                    : null,
                react_1.default.createElement(Grid_1.default, { item: true, xs: 12, sm: 3, md: 2 },
                    react_1.default.createElement(Typography_1.default, { className: classes.spacingBottomOne, variant: "body1" }, strings_1.default.requestTour.selectDay)),
                react_1.default.createElement(Grid_1.default, { item: true, xs: 12, sm: 9, md: 10 },
                    react_1.default.createElement(SelectDays_1.SelectDays, { buttonsContent: dayOptions, initialDays: [], includeWeekends: !props.weekdaysOnly, onChange: onChangeDays }))),
            react_1.default.createElement(Grid_1.default, { container: true, className: classes.spacingTopThree, alignItems: "center" },
                react_1.default.createElement(Grid_1.default, { item: true, xs: 12, sm: 3, md: 2 },
                    react_1.default.createElement(Typography_1.default, { variant: "body1" }, strings_1.default.requestTour.selectTime)),
                react_1.default.createElement(Grid_1.default, { item: true, xs: 12, sm: 9, md: 10 },
                    react_1.default.createElement(SelectDays_1.SelectDays, { buttonsContent: timeOptions, initialDays: [], includeWeekends: !props.weekdaysOnly, onChange: onChangeTime }))),
            react_1.default.createElement(Grid_1.default, { container: true, className: classes.spacingTopThree, alignItems: "center" },
                react_1.default.createElement(Grid_1.default, { item: true, xs: 12 },
                    react_1.default.createElement(Typography_1.default, { variant: "body1" }, strings_1.default.requestTour.comments)),
                react_1.default.createElement(Typography_1.default, { variant: "caption" }, strings_1.default.requestTour.subComments),
                react_1.default.createElement(LimitTextField_1.LimitTextField, { id: "parent-notes", name: "parent-notes", variant: "outlined", size: "small", fullWidth: true, multiline: true, rows: "4", limit: 800, onChange: onUpdateNotes }))),
        props.onSave ? react_1.default.createElement(Button_1.default, { style: { marginTop: "32px", marginBottom: "32px" }, onClick: onSave, variant: "contained", color: "secondary", disabled: (!parentNotes && ((!selectedDays || !selectedDays.length)
                || (!selectedTimes || !selectedTimes.length))), fullWidth: true }, strings_1.default.requestTour.submit) : null));
};
exports.RequestTour = RequestTour;
